export const ZSeries = "Z";
export const AccountInactive = "AccountInactive";
export const AccountLocked = "AccountLocked";
export const PeriodLocked = "PeriodLocked";
export const BadSerie = "BadSerie";
export const VoucherSumNotZero = "VoucherSumNotZero";
